module.exports = __webpack_public_path__ + "static/img/169_TO8_1916_og.9c09c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/169_TO8_1916_og.jpg
// module id = OhLN
// module chunks = 0